<sm-table *ngIf="inited" [data]="table" [allowExport]="false">
</sm-table>
